import api from "utils/api";
import endpoint from "utils/endpoint";
import { plainToClass } from "class-transformer";

import Post from "domain/model/Post";
import Category from "domain/model/Category";
import Template from "domain/model/Template";

class ArticleService {
  fetchEditArticle(
    isAgency: boolean,
    storeId: string | undefined,
    filePath: string
  ): Promise<{ article: Post; content: string | null }> {
    const url =
      isAgency && storeId
        ? endpoint.agency.article.edit(storeId, filePath)
        : endpoint.store.article.edit(filePath);
    return api.get(url).then((res) => {
      return {
        article: plainToClass(Post, res.data.context.post, {
          excludeExtraneousValues: true,
        }),
        content: res.data.context.content,
      };
    });
  }

  async fetchAllArticles(
    isAgency: boolean,
    storeId: string | undefined,
    createdAt?: string
  ): Promise<Post[]> {
    const url =
      isAgency && storeId
        ? endpoint.agency.article.root(storeId)
        : endpoint.store.article.root();
    return api
      .get(url, {
        params: { created_at: createdAt },
      })
      .then((res) =>
        res.data.articles.map((d: Post) =>
          plainToClass(Post, d, { excludeExtraneousValues: true })
        )
      );
  }

  fetchArticleTemplate(
    isAgency: boolean,
    storeId: string | undefined
  ): Promise<Template | null> {
    const url =
      isAgency && storeId
        ? endpoint.agency.article.template(storeId)
        : endpoint.store.article.template();
    return api.get(url).then((res) =>
      plainToClass(Template, res.data.article_template, {
        excludeExtraneousValues: true,
      })
    );
  }

  async fetchCategory(
    isAgency: boolean,
    storeId: string | undefined
  ): Promise<Category[]> {
    const url =
      isAgency && storeId
        ? endpoint.agency.subcategory.article(storeId)
        : endpoint.store.subcategory.article();
    return api.get(url).then((res) => {
      return res.data
        .sort(
          (
            a: { data: { data: { created_at: string } } },
            b: { data: { data: { created_at: string } } }
          ) => {
            const pre: number = parseInt(a.data.data.created_at);
            const cur: number = parseInt(b.data.data.created_at);
            return pre < cur ? 1 : -1;
          }
        )
        .map((d: { data: { data: Category[] } }) => {
          return plainToClass(Category, d.data.data, {
            excludeExtraneousValues: true,
          });
        });
    });
  }
}

export default new ArticleService();
